var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMovingImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMinYMin slice",
    viewBox: "0 0 2450.7 1343.9",
    style: {
      enableBackground: "new 0 0 2450.7 1343.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#6EBECE;}\n\t.st1{opacity:0.2;fill:#04738A;}\n\t.st2{opacity:0.2;fill:#03496A;}\n\t.st3{opacity:0.2;fill:#0F97A1;}\n\t.st4{opacity:0.2;fill:#10596B;}\n\t.st5{opacity:0.7!important;fill:#0CA181!important;}\n\t.st6{opacity:0.5;fill:#46C1C6;}\n\t.st7{opacity:0.5;fill:#6AAECC;}\n\t.st8{opacity:0.2;fill:none;stroke:#24898E;stroke-miterlimit:10;}\n\t.st9{opacity:0.2;fill:#06546F;}\n\t.st10{opacity:0.2;fill:#3D9FBE;}\n\t.st11{opacity:0.7!important;fill:#0CA181!important;}\n\t.st12{opacity:0.2;fill:#047080;}\n\t.st13{opacity:0.7!important;fill:#0CA181!important;}\n\t.st14{opacity:0.5;fill:#4FA893;}\n\t.st15{opacity:0.7!important;fill:#0CA181!important;}\n\t.st16{opacity:0.5;fill:#1A8799;}\n\t.st17{opacity:0.5;fill:#1A848E;}\n\t.st18{opacity:0.5;fill:#5FC6C7;}\n\t.st19{opacity:0.7!important;fill: #0B526C;!important;}\n\t.st20{opacity:0.5;fill:#2694A0;}\n\t.st21{opacity:0.5;fill:#0A6481;}\n\t.st22{opacity:0.5;fill:#57B9CF;}\n\t.st23{opacity:0.8;fill:#4FA893!important}\n\t.st24{opacity:0.5;fill:#0F7F8A;}\n\t.st25{opacity:0.7!important;fill:#0CA181!important;}\n\t.st26{opacity:0.5;fill:#0B8898;}\n\t.st27{opacity:0.2;fill:#0B676A;}\n\t.st28{opacity:5.000000e-02;fill:none;stroke:#24898E;stroke-miterlimit:10;}\n\t.st29{opacity:0.5;fill:#208899;}\n\t.st30{opacity:0.7!important;fill:#0CA181!important;}\n\t.st31{opacity:0.7!important;fill:#0CA181!important;}\n\t.st32{opacity:0.5;fill:#2A9AA6;}\n\t.st33{opacity:0.7!important;fill:#0CA181!important;}\n    .st0{opacity:0.5;fill:#106068;} .st1{opacity:0.5;fill:#1A737C;} .st2{opacity:0.5;fill:#1A8799;} .st3{opacity:0.5;fill:#5FC6C7;} .st4{opacity:0.5;fill:#1A848E;} .st5{opacity:0.5;fill:#208899;} .st6{opacity:0.5;fill:#279AA6;} .st7{opacity:0.5;fill:#0F5C63;} .st8{opacity:0.5;fill:#2694A0;} .st9{opacity:0.5;fill:#167383;} .st10{opacity:0.5;fill:#2A9AA6;} .st11{opacity:0.5;fill:#1C8E78;} .st12{opacity:0.5;fill:#137260;} .st13{opacity:0.3;fill:#6EBECE;} .st14{opacity:0.3;fill:#04738A;} .st15{opacity:0.3;fill:#03496A;} .st16{opacity:0.5;fill:#0A6481;} .st17{opacity:0.5;fill:#57B9CF;} .st18{opacity:0.5;fill:#45B3C5;} .st19{opacity:0.5;fill:#0B526C;} .st20{opacity:0.5;fill:#0F7F8A;} .st21{opacity:0.5;fill:#11636C;} .st22{opacity:0.5;fill:#0B8898;} .st23{opacity:0.3;fill:#0B676A;} .st24{opacity:0.3;fill:#0F97A1;} .st25{opacity:0.3;fill:#10596B;} .st26{opacity:0.3;fill:#0E5767;} .st27{opacity:0.3;fill:#64BFBF;} .st28{opacity:0.3;fill:#2B8383;} .st29{opacity:0.3;fill:#46C1C6;} .st30{opacity:0.3;fill:#206462;} .st31{opacity:0.5;fill:#46C1C6;} .st32{opacity:0.5;fill:#6AAECC;} .st33{opacity:0.3;fill:none;stroke:#24898E;stroke-miterlimit:10;} .st34{opacity:5.000000e-02;fill:none;stroke:#24898E;stroke-miterlimit:10;} .st35{opacity:0.3;fill:#06546F;} .st36{opacity:0.3;fill:#3D9FBE;} .st37{opacity:0.3;fill:#064C6A;} .st38{opacity:0.3;fill:#047080;} .st39{opacity:0.3;fill:#0C638B;} .st40{opacity:0.35;fill:#1A737C;} .st41{opacity:0.3;fill:#2E8887;} .st42{opacity:0.3;fill:#08838B;} .st43{opacity:0.34;fill:#42B0A3;} .st44{opacity:0.5;fill:#128172;} .st45{opacity:0.35;fill:none;stroke:#24898E;stroke-miterlimit:10;} .st46{opacity:0.5;fill:#24898E;} .st47{opacity:0.3;fill:#6CC0BA;} .st48{opacity:0.3;fill:#3896BA;} .st49{opacity:0.5;fill:#086A73;} .st50{opacity:0.35;fill:#0781A0;} .st51{opacity:0.33;fill:none;stroke:#24898E;stroke-miterlimit:10;} .st52{opacity:0.3;fill:#0A6D75;} .st53{opacity:0.3;fill:#0C8270;} .st54{opacity:0.3;fill:#4DB5B9;} .st55{opacity:0.3;fill:#1A737C;} .st56{opacity:0.5;fill:#0CA181;} .st57{opacity:0.35;fill:#328488;} .st58{opacity:0.34;fill:#06938E;} .st59{opacity:0.7!important;fill:#0CA181!important;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "base0"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-41.1,715 -169.8,715.6 -101.5,618.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2.6,563.5 -41.1,715 -101.5,618.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-18.6,372.3 -135.4,405.1 2.6,563.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "-41.1,715 -103.6,794.2 -38,846.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-169.8,715.6 -103.6,794.2 -41.1,715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-136,859 -137.2,807.7 -103.6,794.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "-136,859 -103.6,794.2 -38,846.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "-153.5,499 -135.4,405.1 2.6,563.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-41.1,715 -169.8,715.6 -101.5,618.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-257.5,671 -236.4,569.2 -101.5,618.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-153.5,499 -101.5,618.1 2.6,563.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-236.4,569.2 -101.5,618.1 -153.5,499  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-257.5,671 -169.8,715.6 -101.5,618.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "2.6,563.5 -41.1,715 -101.5,618.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-18.6,372.3 -135.4,405.1 2.6,563.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-41.1,715 -103.6,794.2 -38,846.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-169.8,715.6 -103.6,794.2 -41.1,715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-169.8,715.6 -137.2,807.7 -103.6,794.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-136,859 -137.2,807.7 -103.6,794.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "-153.5,499 -101.5,618.1 2.6,563.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-257.5,671 -169.8,715.6 -101.5,618.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "-236.4,569.2 -101.5,618.1 -153.5,499  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "-169.8,715.6 -137.2,807.7 -103.6,794.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "-257.5,671 -236.4,569.2 -101.5,618.1  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "base1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "30.2,984 -37.8,844.3 77.8,774.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "50.9,713.1 -41.1,715 1.8,568.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "77.8,774.6 144.2,896.7 30.2,984  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "235.7,825.7 77.8,774.6 180.9,746.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "77.8,774.6 144.2,896.7 235.7,825.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "77.8,774.6 50.9,713.1 180.9,746.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "-37.6,843.7 -41.1,715 50.9,713.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "97,592.1 50.9,713.1 0,563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "-37.8,844.3 77.8,774.6 50.9,713.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "180.9,746.7 97,592.1 50.9,713.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "129.1,515.9 2.6,563.5 -18.6,372.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "97,592.1 2.6,563.5 129.1,515.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "133.9,390.3 -18.6,372.3 129.1,515.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "-38,846.5 -136,859 29.9,985.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "129.1,515.9 2.6,563.5 -18.6,372.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "97,592.1 2.6,563.5 129.1,515.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "133.9,390.3 -18.6,372.3 129.1,515.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-38,846.5 -136,859 29.9,985.1  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "base2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "260,503.4 258.2,428.6 129.1,515.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "133.9,390.3 284.8,312.6 129.1,515.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "258.2,428.6 284.8,312.6 129.1,515.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "268,866 85.4,941.7 235.7,825.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "265.7,770.1 235.7,825.7 294.4,824.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "268,866 294.4,824.3 235.7,825.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "265.7,770.1 180.9,746.7 235.7,825.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "387.1,605.9 180.9,746.7 265.7,770.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "97,592.1 180.9,746.7 387.1,605.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "259,504.2 99.1,592.2 387.1,605.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st32",
    points: "387.1,605.9 414.4,684.9 265.7,770.1 387.1,605.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "411.9,576.7 387.1,605.9 257.4,502.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "332.3,989.6 243.3,1034.5 299.9,946.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "396.4,887 332.3,989.6 299.9,946.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "294.4,824.3 299.9,946.3 396.4,887  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "86.1,941.7 299.9,946.3 268,866  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "299.9,946.3 268,866 294.4,824.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "258.5,504.1 129.1,515.9 97.7,592  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "396.4,887 295.4,824.3 469.3,825.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "265.7,770.1 294.4,824.3 469.3,825.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "496.7,906.4 396.4,887 469.3,825.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "396.4,887 474,1022.1 332.3,989.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "258.5,504.1 129.1,515.9 97.7,592  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "260,503.4 258.2,428.6 129.1,515.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "133.9,390.3 284.8,312.6 129.1,515.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "258.2,428.6 284.8,312.6 129.1,515.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "396.4,887 295.4,824.3 469.3,825.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "265.7,770.1 294.4,824.3 469.3,825.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "496.7,906.4 396.4,887 469.3,825.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "396.4,887 474,1022.1 332.3,989.6  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "nearright"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M289.8 766.6L493.5 822l-55-140.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M513.6 915.4l-13.3 117.2L412 904.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M272 503l124.3-57.4L270 428.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M414 447.3L441.2 578l-106.7-51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M420.4 685l-2.6-108-24.7 29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M305 764.2L509 819.6l-55-140.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M513.6 915.4l-13.3 117.2L412 904.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M399.3 440.4L273 423l26.6-116 99.7 133.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M272 503l124.3-57.4L270 428.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M272 503l45 22.4 79.3-79.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M272 503l45 22.4 79.3-79.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M412 447.6l27.3 130.7-106.7-51z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "top"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M-22.5 335.5l126.2-101 26.4 119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M442.7 423.3l20.5-160.5-120 27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M-22.5 335.5l126.2-101 26.4 119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M145 321.3l-26.2-119L296 243.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M148.3 311.4l-26.4-119 177 41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M470 251.7l-122-37L392.3 104 470 251.7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "bottom"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M23.4 1031.5l213.3 49.4-157-93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M27.3 1033l213.3 49.3-157-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M481 1064.7l-32.5 95.3-50.8-36zM124.2 1235.6L8.6 1188l69.3 74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M142 1232.4l-115.6-47.6 69.3 74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M142 1101.2l60.5 56.5-83.2 59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M150.5 1086.7l60.6 56.5-83 59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M483 1054.7l-32.5 95.3-50.8-36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M287.8 957.3L74 952.7l157.2 92.8z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "farright"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M684.3 738l-120.6 32.6L664 787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M693.5 532.6L869 640.4l-120.6 32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M481.5 490.4l92.7-58.7-87 192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M527.8 314.7l82-73-61.4-87.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M695.7 736L575 769l100.4 16.6zM684.5 551.8l175.5 108-120.6 32.6zM517.3 483l92.8-58.6-87 192z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovingImage);
export default __webpack_public_path__ + "static/media/moving-image.a93e95da.svg";
export { ForwardRef as ReactComponent };